import * as React from "react";
import { durationInSeconds, durationInMinutes } from "util/DateTime";
import Pluralize from "./Pluralize";
const ReadableDuration = ({ duration }) => {
  const durationInSec = durationInSeconds(duration);
  const durationInMin = durationInMinutes(duration);
  if (durationInSec < 60) {
    return /* @__PURE__ */ React.createElement("span", null, durationInSec, " ", /* @__PURE__ */ React.createElement(Pluralize, { singular: "second", plural: "seconds", value: durationInSec }));
  }
  return /* @__PURE__ */ React.createElement("span", null, durationInMin, " ", /* @__PURE__ */ React.createElement(Pluralize, { singular: "minute", plural: "minutes", value: durationInMin }));
};
export default ReadableDuration;
